export { default } from './WechatShareGuide';